import * as THREE from 'three';
import Experience from '../Experience';
import {
  EffectComposer,
  EffectPass,
  RenderPass,
  GodRaysEffect,
  BloomEffect,
  NoiseEffect,
  VignetteEffect,
  ChromaticAberrationEffect,
  DepthOfFieldEffect,
} from "postprocessing";

export default class PostProcessor {
    constructor() {
        this.experience = new Experience();
        // this.scene = this.experience.scene;
        this.renderer = this.experience.renderer.instance;
        this.camera = this.experience.camera.instance;
        this.scene = this.experience.scene;

        this.setupPostProcessing();
        this.createSunMesh();

    }

    setupPostProcessing() {
        // 创建 EffectComposer
        this.composer = new EffectComposer(this.renderer, {
            frameBufferType: THREE.HalfFloatType
        });

        // 添加基础渲染通道
        const renderPass = new RenderPass(this.scene, this.camera);
        this.composer.addPass(renderPass);

        // 创建太阳网格作为 GodRays 的光源
        this.createLightSource();

        // 添加 GodRays 效果
        this.godRaysEffect = new GodRaysEffect(this.camera, this.sunMesh, {
            height: 480,           // GodRays 分辨率
            kernelSize: 2,      // 光线强度
            density: 0.96,        // 密度
            decay: 0.90,          // 衰减
            weight: 0.85,          // 权重
            exposure: 0.2,        // 曝光
            samples: 60,          // 采样数
            clampMax: 1.0
        });

        // 添加噪声效果
        this.noiseEffect = new NoiseEffect({ premultiply: true });
        this.vignetteEffect = new VignetteEffect({
            eskil: false,
            offset: 0.4,
            darkness: 0.7
        });

        this.chromaticAberrationEffect = new ChromaticAberrationEffect({
            offset: new THREE.Vector2(0.001, 0.001)
        });
        this.composer.addPass(new EffectPass(this.camera, this.godRaysEffect,this.chromaticAberrationEffect, this.noiseEffect, this.vignetteEffect));

        // 调试信息
        if (this.experience.debug.active) {
            // this.setupDebug();
        }
    }

   createLightSource() {
        // 创建太阳网格作为 GodRays 光源
        const sunGeometry = new THREE.PlaneGeometry(10, 10);
        const sunMaterial = new THREE.MeshBasicMaterial({
            color: 0xffa600,
            transparent: true,
            opacity: 0.15,
        });
        
        this.sunMesh = new THREE.Mesh(sunGeometry, sunMaterial);
        this.sunMesh.position.set(5,5, -8); // 设置太阳位置
        this.sunMesh.frustumCulled = false; // 防止被裁剪
        
       


    }
    createSunMesh() {
        // 为了兼容，保持这个方法
        if (!this.sunMesh) {
            this.createLightSource();
        }
    }
    setupDebug() {
        const debugFolder = this.experience.debug.ui.addFolder('PostProcessor');
        
        // GodRays 控制
        const godRaysFolder = debugFolder.addFolder('GodRays');
        godRaysFolder.add(this.godRaysEffect, 'kernelSize', 0, 5, 1).name('Kernel Size');
        // godRaysFolder.add(this.godRaysEffect, 'decay', 0.8, 1.0, 0.001).name('Decay');
        // godRaysFolder.add(this.godRaysEffect, 'weight', 0.0, 1.0, 0.01).name('Weight');
        // godRaysFolder.add(this.godRaysEffect, 'exposure', 0.0, 1.0, 0.01).name('Exposure');
        // godRaysFolder.add(this.godRaysEffect, 'samples', 30, 100, 1).name('Samples');

        // 太阳位置控制
        const sunFolder = debugFolder.addFolder('Sun Position');
        sunFolder.add(this.sunMesh.position, 'x', -50, 50, 0.1).name('Sun X');
        sunFolder.add(this.sunMesh.position, 'y', -50, 50, 0.1).name('Sun Y');
        sunFolder.add(this.sunMesh.position, 'z', -50, 50, 0.1).name('Sun Z');

        // Bloom 控制
        const bloomFolder = debugFolder.addFolder('Bloom');
        bloomFolder.add(this.bloomEffect, 'intensity', 0.0, 3.0, 0.01).name('Intensity');
        bloomFolder.add(this.bloomEffect, 'luminanceThreshold', 0.0, 2.0, 0.01).name('Threshold');

        // 太阳材质控制
        const sunMaterialFolder = debugFolder.addFolder('Sun Material');
        sunMaterialFolder.add(this.sunMesh.material, 'opacity', 0.0, 1.0, 0.01).name('Opacity');
        sunMaterialFolder.addColor({ color: this.sunMesh.material.color.getHex() }, 'color')
            .onChange((value) => {
                this.sunMesh.material.color.setHex(value);
            }).name('Color');
    }
    setSunPosition(x, y, z) {
        if (this.sunMesh) {
            this.sunMesh.position.set(x, y, z);
            console.log('Sun position updated to:', x, y, z);
        }
    }
    setGodRaysIntensity(intensity) {
        if (this.godRaysEffect) {
            this.godRaysEffect.weight = intensity;
        }
    }

    resize(width, height) {
        this.composer.setSize(width, height);
    }

    update() {
        // 使用 composer 渲染而不是直接渲染场景
        this.sunMesh.lookAt(this.camera.position); // 让太阳始终面向摄像机
        this.composer.render();
    }

    dispose() {
        this.composer.dispose();
        if (this.sunMesh) {
            this.scene.remove(this.sunMesh);
            this.sunMesh.geometry.dispose();
            this.sunMesh.material.dispose();
        }
    }
}